import React from 'react';
import { createRoot } from 'react-dom/client';
import AppWithConfig from './AppWithConfig';
import './index.css';
import './_lib/i18n';

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<AppWithConfig />);
} 